
































import Vue from "vue";
export default Vue.extend({
  name: "Combo",
  data() {
    return {
      tag: "",
      search: "",
      showError: false,
      textError: "",
    };
  },
  methods: {
    //Se obtiene los datos del localstorage y se parsea.
    getTagsFromLocalStorage(): string[] {
      let tags = [] as string[];
      if (localStorage.getItem("defaultTags")) {
        const tagsRaw = (localStorage.getItem("defaultTags") as string) ?? "[]";
        tags = JSON.parse(tagsRaw) as string[];
      }
      return tags.map((tag) => {
        return this.normalizeTag(tag);
      });
    },
    normalizeTag(tag: string): string {
      return tag
        .replace(/[^\w\s:\s-]/gi, "")
        .toLowerCase()
        .trim();
    },
    //Funcion que envia el tag al componante padre.
    onKeyDownCombo() {
      if (this.tag != null && this.tag.match(/^[^:]+:[^:]+$/)) {
        this.$emit("addTags", this.normalizeTag(this.tag));
        this.$nextTick(() => {
          this.resetVariables();
        });
      }
    },
    //Aqui reseteamos las variables
    resetVariables() {
      this.tag = "";
      this.search = "";
    },
    onChange() {
      if (this.tag != null) {
        !this.tag.includes(":") ? (this.tag = `${this.tag}:`) : `${this.tag}`;
      }
    },
  },
  computed: {
    tags(): string[] {
      const tagsNormalized = this.getTagsFromLocalStorage();
      return tagsNormalized;
    },
  },
});
